// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos personalizados para la página de Gestión */

/* Transiciones suaves para los botones de navegación */
.nav-button {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.nav-button:hover {
  transform: translateY(-2px);
}

.nav-button.active {
  transform: scale(1.05);
}

/* Efectos de hover para las tarjetas */
.hover-scale {
  transition: transform 0.2s ease-in-out;
}

.hover-scale:hover {
  transform: scale(1.02);
}

/* Animaciones para las tablas */
.table-fade-in {
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Estilos para los badges de estado */
.status-badge {
  transition: all 0.2s ease-in-out;
}

.status-badge:hover {
  transform: scale(1.05);
}

/* Efectos para los formularios */
.form-container {
  transition: all 0.3s ease-in-out;
}

.form-container:hover {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

/* Responsive grid para navegación */
@media (max-width: 768px) {
  .nav-grid {
    grid-template-columns: 1fr;
  }

  .nav-button {
    padding: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/gestion.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD,uDAAuD;AACvD;EACE,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC;EACE,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sCAAsC;AACtC;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,oCAAoC;AACpC;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Estilos personalizados para la página de Gestión */\r\n\r\n/* Transiciones suaves para los botones de navegación */\r\n.nav-button {\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.nav-button:hover {\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.nav-button.active {\r\n  transform: scale(1.05);\r\n}\r\n\r\n/* Efectos de hover para las tarjetas */\r\n.hover-scale {\r\n  transition: transform 0.2s ease-in-out;\r\n}\r\n\r\n.hover-scale:hover {\r\n  transform: scale(1.02);\r\n}\r\n\r\n/* Animaciones para las tablas */\r\n.table-fade-in {\r\n  animation: fadeIn 0.5s ease-in-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* Estilos para los badges de estado */\r\n.status-badge {\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.status-badge:hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n/* Efectos para los formularios */\r\n.form-container {\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n\r\n.form-container:hover {\r\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Responsive grid para navegación */\r\n@media (max-width: 768px) {\r\n  .nav-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .nav-button {\r\n    padding: 1rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
